<template>
    <div v-if="ready">
        <form
            class="form-horizontal"
            enctype="multipart/form-data"
            @keydown="form.errors.clear($event.target.name)"
            autocomplete="off"
        >
            <form-input :form="form" type="text" name="name" label="project_name" required/>

            <dual-select
                inputLabel="app.project_managers"
                :error="form.errors.get('project_managers')"
                name="project_managers"
                :route="route('relations.index', {role: 'project_manager'})"
                v-model="form.project_managers"
                required
            />

<!--             <backend-select :form="form" :error="form.errors.get('project_managers')" name="project_managers" return="id"
                            label="project_managers" :route="route('admin.roles.relations', {role: 5})"
                            :value="field('project_managers')" v-model="form.project_managers" object-name-key="full_name" multiple required/>
 -->

            <div class="form-group row">
                <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label" for="contract">{{ uLang('app.contract') }}</label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <form-file id="contract" v-model="form['contract']" :placeholder="uLang('app.no_file_chosen')" :choose-label="uLang('app.choose_file')"/>
                </div>
            </div>

            <form-daterange-picker :form="form" name_1="start_date" name_2="end_date"
                                   :label="uLang('app.start_and_end_dates')" required/>

            <backend-select :error="form.errors.get('client_id')" name="client_id" label="client" return="id"
                            :route="route('admin.types.organisations', {type: 2})"
                            :value="field('client_id')" v-model="form.client_id"/>

            <form-select :error="form.errors.get('contact_id')" object-name-key="display_name" track-by="id" :required="!!form.client_id"
                         :value="field('contact_id')" v-model="contact" :options="contacts" name="contact_id"
                         label="contact" :loading="fields_loading.contacts" :disabled="!form.client_id"/>

            <label-select
                    object-name-key="display_name"
                    object-value-key="id"
                    :error="form.errors.get('department')"
                    :value="form.department"
                    name="department"
                    :options="departments"
                    v-model="form.department"
                    track-by="id"
            />

            <form-textarea :form="form" name="results_appointments" rows="6"/>

            <backend-select
                :error="form.errors.get('selling_cost_center_id')"
                name="selling_cost_center_id"
                label="selling_cost_center"
                :route="route('settings.values.index', { setting: 4 })"
                track-by="value"
                return="id"
                :value="field('selling_cost_center_id')"
                v-model="form.selling_cost_center_id"
                object-name-key="value"
            />

            <backend-select
                :error="form.errors.get('purchase_cost_center_id')"
                name="purchase_cost_center_id"
                label="purchase_cost_center"
                :route="route('settings.values.index', { setting: 4 })"
                track-by="value"
                return="id"
                :value="field('purchase_cost_center_id')"
                v-model="form.purchase_cost_center_id"
                object-name-key="value"
            />


            <form-input :form="form" type="number" name="expected_trajectories" label="expected_trajectories"/>

            <form-input :form="form" type="number" name="maximum_trajectories" label="maximum_trajectories"/>

            <form-input :form="form" type="number" name="lead_fee" label="lead_fee" step="0.01" min="0" max="100"/>

            <form-input :form="form" type="number" name="acquisition_fee" label="acquisition_fee" step="0.01" min="0" max="100"/>

            <form-input :form="form" type="text" name="client_project_number" label="client_project_number"/>

            <div class="form-group row">
                <label class="form-control-label col-md-3 col-xl-2 col-sm-12 col-form-label" for="accumulated_invoice">{{ uLang('app.accumulated_invoice') }}</label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <label class="custom-control custom-checkbox mt-2">
                        <input type="checkbox" class="custom-control-input" id="accumulated_invoice" v-model="form['accumulated_invoice']">
                        <span class="custom-control-indicator"></span>
                    </label>
                </div>
            </div>

            <active-select
                :error="form.errors.get('active')"
                return="id"
                :value="field('active')"
                v-model="form.active"
                required
            />
        </form>

        <div class="form-group fr-absolute">
            <input :disabled="form.busy" type="submit" class="btn btn-brand" @click.prevent="store()"
                   :value="isUpdate() ? uLang('app.save') : uLang('app.add_type', { type: lang('app.trajectory_project')})"/>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { event }  from '~/events'
    import FormMixin from '~/mixins/form'
    import DualSelect from '~/Form/elements/dual-select'
    import SuccessfullyStoredAlert from "~/Swals/SuccessfullyStoredAlert";
    import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";
    import LabelSelect from "~/components/elements/selects/label";

    export default {
        name: 'trajectory-projects-form',
        components: {
            'dual-select': DualSelect,
            'label-select': LabelSelect
        },
        mixins: [FormMixin],
        props: {
            id: {
                required: false,
            },
        },

        data() {
            return {
                departments: [],
                entity: 'trajectory-projects',
                form: new Form({
                    name: '',
                    selling_cost_center_id: null,
                    purchase_cost_center_id: null,
                    project_managers: null,
                    start_date: '',
                    end_date: '',
                    client_id: null,
                    contact_id: null,
                    department: '',
                    contract: '',
                    results_appointments: '',
                    expected_trajectories: '',
                    maximum_trajectories: '',
                    lead_fee: '',
                    acquisition_fee: '',
                    client_project_number: '',
                    accumulated_invoice: null,
                    active: 0,
                }),
                contact: null,
                contacts: [],
                fields_loading: {
                    contacts: false,
                    reporting_persons: false,
                },
                swal: false,
            }
        },

        computed: {
            client_id() {
                return this.form.client_id
            }
        },

        watch: {
            client_id(newVal, oldVal) {
                if (newVal !== null) {
                    this.retrieveContacts(newVal);
                } else {
                    this.contact = null;
                }
            },

            contact(newVal, oldVal) {
                if (newVal !== null) {
                    this.form.contact_id = newVal.id;
                } else {
                    this.form.contact_id = null;
                }
            },
        },

        created() {
            this.departments = window.config.departments;
            this.$on('afterRetrieve', this.afterRetrieve);
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);
        },

        methods: {
            afterStore(data) {
                new SuccessfullyStoredAlert({entity: this.lang('app.trajectory_project')}).show()
                    .then((buttonPressed) => {
                        if (buttonPressed === 'create_another') {
                            // Form mixin clears fields already
                        } else if (buttonPressed === 'show') {
                            this.$router.push({name: 'admin.trajectory_projects.view', params: { id: data.id }});
                        }
                    });
            },

            afterUpdate(data) {
                new SuccessfullyUpdatedAlert({entity: this.lang('app.trajectory_project')}).show()
                    .then(() => {
                        this.$router.push({name: 'admin.trajectory_projects.view', params: { id: this.id }});
                    });
            },

            afterRetrieve(data) {
                if (this.isUpdate() || this.duplicates()) {
                    this.contact = data.contact;

                    // Set them to null so we don't try to store objects
                    this.form.contract = null;
                    this.form.originalData.contract = null;
                }
            },

            async retrieveContacts(organisationId) {
                this.fields_loading.contacts = true;
                const { data } = await window.axios.get(route('organisations.relations.index', {organisation: organisationId, role: ['contact']}));
                this.contacts = data;
                this.fields_loading.contacts = false;
            },

            show() {
                this.$router.push({ name: 'admin.trajectory_projects.view', params: { id: this.id }})
            },
        }
    }
</script>

<style lang="css" scoped>
    .remove-address {
        margin-right: 20px;
    }
</style>
